module.exports = __webpack_public_path__ + "static/media/users (5).00c52bdf.svg";